import { render } from "./Toys.vue?vue&type=template&id=b6dc9974"
import script from "./Toys.vue?vue&type=script&lang=js"
export * from "./Toys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__